import { useContext } from "react";
import { ToolContext } from "../../context/ToolContext";
import { Snackbar } from "@mui/material";

export const SuperSnackbarUnsuc = () => {
    const { snack_stateunsuc } = useContext(ToolContext);
	    return (
	    	<Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={snack_stateunsuc.alertVal.data.isOpen} autoHideDuration={2000}  message={snack_stateunsuc.alertVal.data.textBody} sx={{ mb:"80px",width: 'auto',}} ContentProps={{sx: {display: 'block',textAlign: "center", background: "#F44336"}}}></Snackbar>
	    );
  };